/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantSocialLinks } from './TenantSocialLinks';
import {
    TenantSocialLinksFromJSON,
    TenantSocialLinksFromJSONTyped,
    TenantSocialLinksToJSON,
} from './TenantSocialLinks';

/**
 * Tenant-self-serve subset of tenant configuration, editable by tenant admins (unlike the manager-only Tenant record). Intended home for miscellaneous per-tenant options.
 * @export
 * @interface TenantOptions
 */
export interface TenantOptions {
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    name_short?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    support_email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    info_email?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    default_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantOptions
     */
    company_website?: string;
    /**
     * Tenant-wide default cancellation/credit window (hours), 0-168. Mirrors Tenant.default_refund_window_hours (per-concern overrides still win). Unlike the other self-serve fields, OMITTING this field in a PUT clears it (the form omits the key when emptied) — cleared means cancellations are never credited unless a concern sets a window.
     * @type {number}
     * @memberof TenantOptions
     */
    default_refund_window_hours?: number;
    /**
     * IANA timezone the tenant operates in (e.g. America/Toronto). Omitted in a PUT = unchanged; when set it must be a valid IANA zone name. Everything falls back to America/Toronto while unset.
     * @type {string}
     * @memberof TenantOptions
     */
    timezone?: string;
    /**
     * 
     * @type {TenantSocialLinks}
     * @memberof TenantOptions
     */
    social_links?: TenantSocialLinks;
}

/**
 * Check if a given object implements the TenantOptions interface.
 */
export function instanceOfTenantOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantOptionsFromJSON(json: any): TenantOptions {
    return TenantOptionsFromJSONTyped(json, false);
}

export function TenantOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'name_short': !exists(json, 'name_short') ? undefined : json['name_short'],
        'support_email': !exists(json, 'support_email') ? undefined : json['support_email'],
        'info_email': !exists(json, 'info_email') ? undefined : json['info_email'],
        'default_phone': !exists(json, 'default_phone') ? undefined : json['default_phone'],
        'company_website': !exists(json, 'company_website') ? undefined : json['company_website'],
        'default_refund_window_hours': !exists(json, 'default_refund_window_hours') ? undefined : json['default_refund_window_hours'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'social_links': !exists(json, 'social_links') ? undefined : TenantSocialLinksFromJSON(json['social_links']),
    };
}

export function TenantOptionsToJSON(value?: TenantOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'name_short': value.name_short,
        'support_email': value.support_email,
        'info_email': value.info_email,
        'default_phone': value.default_phone,
        'company_website': value.company_website,
        'default_refund_window_hours': value.default_refund_window_hours,
        'timezone': value.timezone,
        'social_links': TenantSocialLinksToJSON(value.social_links),
    };
}

